import { Component, Vue } from "vue-property-decorator";
import { BadRequestError, NotFoundError, ContrattiCreateBody, ContrattiReplaceBody, ContrattiIncludeParams, ContrattiReturned, ContrattiFilterParams, ContrattiDateBody, InvalidBodyError, InvalidPathParamError, ContrattiPDFTypes, ContrattiCheckoutBody } from "operatn-api-client";

import { ActionTypes, AlertType } from "@/store";

@Component
export default class ContrattoHandlerMixin extends Vue {

  /* METHODS */

  async getContratti(params: ContrattiIncludeParams & ContrattiFilterParams = {}, alertType = AlertType.ERROR_ALERT): Promise<ContrattiReturned[]> {
    try {
      return await this.$api.contratti.getAll(params, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Impossibile caricare i contratti`, alertType });
      }
      throw error;
    }
  }

  async getContrattiDaFirmare(params: ContrattiIncludeParams & ContrattiFilterParams = {}, alertType = AlertType.ERROR_ALERT): Promise<ContrattiReturned[]> {
    try {
      return await this.$api.contratti.getDaFirmare(params, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Impossibile caricare i contratti`, alertType });
      }
      throw error;
    }
  }

  async getContrattiDaFirmareChiusura(params: ContrattiIncludeParams & ContrattiFilterParams = {}, alertType = AlertType.ERROR_ALERT): Promise<ContrattiReturned[]> {
    try {
      return await this.$api.contratti.getDaFirmareChiusura(params, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Impossibile caricare i contratti`, alertType });
      }
      throw error;
    }
  }

  async getContrattiDaVisionare(params: ContrattiIncludeParams & ContrattiFilterParams = {}, alertType = AlertType.ERROR_ALERT): Promise<ContrattiReturned[]> {
    try {
      return await this.$api.contratti.getDaVisionare(params, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Impossibile caricare i contratti`, alertType });
      }
      throw error;
    }
  }

  async getContrattiFirmati(params: ContrattiIncludeParams & ContrattiFilterParams = {}, alertType = AlertType.ERROR_ALERT): Promise<ContrattiReturned[]> {
    try {
      return await this.$api.contratti.getFirmati(params, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Impossibile caricare i contratti`, alertType });
      }
      throw error;
    }
  }

  async getContrattiAttivi(params: ContrattiIncludeParams & ContrattiFilterParams = {}, alertType = AlertType.ERROR_ALERT): Promise<ContrattiReturned[]> {
    try {
      return await this.$api.contratti.getAttivi(params, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Impossibile caricare i contratti`, alertType });
      }
      throw error;
    }
  }

  async getContrattiFuturi(params: ContrattiIncludeParams & ContrattiFilterParams = {}, alertType = AlertType.ERROR_ALERT): Promise<ContrattiReturned[]> {
    try {
      return await this.$api.contratti.getFuturi(params, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Impossibile caricare i contratti`, alertType });
      }
      throw error;
    }
  }

  async getContrattiTerminati(params: ContrattiIncludeParams & ContrattiFilterParams = {}, alertType = AlertType.ERROR_ALERT): Promise<ContrattiReturned[]> {
    try {
      return await this.$api.contratti.getTerminati(params, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Impossibile caricare i contratti`, alertType });
      }
      throw error;
    }
  }

  async getContratto(id: number, params: ContrattiIncludeParams & ContrattiFilterParams = {}, alertType = AlertType.ERROR_ALERT): Promise<ContrattiReturned> {
    try {
      return await this.$api.contratti.get(id, params, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }


  async getContrattoByToken(token: string, params: ContrattiIncludeParams = {}, alertType = AlertType.ERROR_ALERT): Promise<ContrattiReturned> {
    try {
      return await this.$api.contratti.getByToken(token, params, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }

  async createContratto(body: ContrattiCreateBody, alertType = AlertType.ERROR_ALERT): Promise<number> {
    try {
      const id = await this.$api.contratti.create({ ...body }, { alertType });
      return id;
    } catch (error) {
      if (error) {
        if (error instanceof InvalidBodyError) {
          this.$store.dispatch(ActionTypes.ALERT, { message: `Dati del contratto da creare non validi`, alertType });
        } else if (error instanceof BadRequestError) {
          this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
        } else {
          this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
        }
      }
      throw error;
    }
  }

  async updateContratto(id: number, body: ContrattiReplaceBody, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      await this.$api.contratti.replace(id, {
        dataInizio: body.dataInizio,
        dataFine: body.dataFine,
        checkout: body.checkout,
        cauzione: body.cauzione,
        tipoRata: body.tipoRata,
        idTariffa: body.idTariffa,
        idTipoContratto: body.idTipoContratto,
        idQuietanziante: body.idQuietanziante,
        ospiti: body.ospiti,
        note: body.note,
      }, { alertType });
    } catch (error) {
      if (error) {
        if (error instanceof InvalidPathParamError) {
          this.$store.dispatch(ActionTypes.ALERT, { message: `Id contratto non valido`, alertType });
        } else if (error instanceof InvalidBodyError) {
          this.$store.dispatch(ActionTypes.ALERT, { message: `Dati da aggiornare del contratto non validi`, alertType });
        } else if (error instanceof NotFoundError) {
          this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
        } else if (error instanceof BadRequestError) {
          this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida.`, alertType });
        }
      }
      throw error;
    }
  }

  async closeContrattoInAnticipo(id: number, body: ContrattiDateBody, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      return await this.$api.contratti.chiudiAnticipatamente(id, body, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }

  async sendContrattoEmailFirma(id: number, type: ContrattiPDFTypes, lang = 'it', alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      return await this.$api.contratti.sendEmailFirma(id, type, lang, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }

  async uploadContrattoFirma(id: number, formData: FormData, type: ContrattiPDFTypes, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      return await this.$api.contratti.uploadFirma(id, formData, type, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }

  async uploadContrattoFirmaFromEmail(token: string, formData: FormData, type: ContrattiPDFTypes, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      return await this.$api.contratti.uploadFirmaFromEmail(token, formData, type, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }

  async answerContrattoFirmaFromEmail(id: number, body: { accettato: boolean }, type: ContrattiPDFTypes, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      return await this.$api.contratti.answerFirmaFromEmail(id, body, type, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }

  async addCheckIn(id: number, oid: number, body: ContrattiDateBody, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      return await this.$api.contratti.addCheckIn(id, oid, body, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }

  async addCheckOut(id: number, oid: number, body: ContrattiCheckoutBody, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      return await this.$api.contratti.addCheckOut(id, oid, body, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }

  async deleteCheckIn(id: number, oid: number, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      return await this.$api.contratti.deleteCheckIn(id, oid, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }

  async deleteCheckOut(id: number, oid: number, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      return await this.$api.contratti.deleteCheckOut(id, oid, { alertType });
    } catch (error) {
      if (error instanceof NotFoundError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
      } else if (error instanceof BadRequestError) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida`, alertType });
      } else {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore del server`, alertType });
      }
      throw error;
    }
  }

  async getPdfQuestura(id: number, oid: number, alertType = AlertType.NONE): Promise<string> {
    try {
      return await this.$api.contratti.getPdfQuestura(id, oid, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore nel prendere il pdf questura`, alertType });
      }
      throw error;
    }
  }

  async postPdfQuestura(id: number, oid: number, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      await this.$api.contratti.postPdfQuestura(id, oid, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore nel creare il pdf questura`, alertType });
      }
      throw error;
    }
  }

  async deleteContratto(id: number, alertType = AlertType.ERROR_ALERT): Promise<void> {
    try {
      await this.$api.contratti.delete(id, { alertType });
    } catch (error) {
      if (error) {
        if (error instanceof InvalidPathParamError) {
          this.$store.dispatch(ActionTypes.ALERT, { message: `Id contratto non valido`, alertType });
        } else if (error instanceof NotFoundError) {
          this.$store.dispatch(ActionTypes.ALERT, { message: `Contratto non trovato`, alertType });
        } else if (error instanceof BadRequestError) {
          this.$store.dispatch(ActionTypes.ALERT, { message: `Richiesta non valida.`, alertType });
        }
      }
      throw error;
    }
  }

  async getPdfContratto(id: number, type: ContrattiPDFTypes, lang?: string, alertType = AlertType.ERROR_ALERT): Promise<Blob> {
    try {
      return await this.$api.contratti.getPdf(id, type, lang, { alertType });
    } catch (error) {
      if (error) {
        this.$store.dispatch(ActionTypes.ALERT, { message: `Errore nel creare il pdf`, alertType });
      }
      throw error;
    }
  }

  

}